import { cn } from '@/context/global/utils/cn';

export type TSearchIconProps = {
  className?: string;
  size?: number;
};

export default function IconSearch({ className = '', size = 24 }: TSearchIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <g clipPath="url(#clip0_1_24693)">
        <path
          d="M16.0762 14.5192H15.257L14.9666 14.2392C15.9829 13.057 16.5948 11.5222 16.5948 9.85256C16.5948 6.12959 13.577 3.11182 9.85402 3.11182C6.13106 3.11182 3.11328 6.12959 3.11328 9.85256C3.11328 13.5755 6.13106 16.5933 9.85402 16.5933C11.5237 16.5933 13.0585 15.9814 14.2407 14.9651L14.5207 15.2555V16.0748L19.7059 21.2496L21.2511 19.7044L16.0762 14.5192ZM9.85402 14.5192C7.2718 14.5192 5.18736 12.4348 5.18736 9.85256C5.18736 7.27033 7.2718 5.18589 9.85402 5.18589C12.4362 5.18589 14.5207 7.27033 14.5207 9.85256C14.5207 12.4348 12.4362 14.5192 9.85402 14.5192Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_24693">
          <rect width="24.8889" height="24.8889" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
